// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hEft","controls":"styles_controls__2TlHA","charLimit":"styles_charLimit__GWfmU","input":"styles_input__3Ga46","send":"styles_send__dCmDR"};